import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { translator } from "../../utils/i18n";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";

export default function ConfirmDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const clickFunc = () => {
    props.handleClick();
    handleClose();
  };

  return (
    <>
      <Tooltip title={translator()._("W_SUPPRIMER")}>
        <button onClick={handleClickOpen}>
          <DeleteOutlineIcon />
          <span className="text">{translator()._("W_SUPPRIMER")}</span>
        </button>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <DialogContentText>{props.label}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            {translator()._("W_ANNULER")}
          </Button>
          <Button onClick={() => clickFunc()} color="primary" autoFocus>
            {translator()._("W_OUI")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfirmDialog.propTypes = {
  handleClick: PropTypes.func,
  label: PropTypes.string
};
